import { queryBot2 } from 'boot/axios';

export function calcEmpty (value = undefined) {
    return !value || value === null || value === '' || value === 0 || value === '0' || value === 'null' || value === 'NULL';
}

export function calcObject (obj = undefined, param = undefined) {
    if (!obj || typeof obj !== 'object') {
        return undefined;
    }
    if (param) {
        return calcEmpty(obj[param]) ? undefined : obj[param];
    }
    return obj;
}

export function calcDate (current = undefined) {
    const date = !calcEmpty(current) ? Date.parse(current) : Date.now();
    const datetime = new Date(date);
    const offset = datetime.getTimezoneOffset();
    const dt = new Date(parseInt(datetime.getTime(), 10) - (offset * 60000));
    return dt.toISOString().replace(/[T]|.\d{3}Z/g, ' ').trim();
}

export async function calcUsersInProject (projectId) {
    return queryBot2('calcUsersInProject', { projectId }).then((r) => {
        let calc;
        const result = r.data;
        if (result && typeof result === 'object') {
            calc = Object.values(result).length;
        }
        return calc;
    });
}

export async function calcCourseTitle (id) {
    return queryBot2('calcCourseTitle', { id }).then((r) => {
        let calc;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            calc = result.title;
        }
        return calc;
    });
}

export function calcProjectLikes (likes, val) {
    if (!likes || typeof likes !== 'object') {
        likes = [val];
    } else if (likes.filter(i => i === val).length) {
        likes = likes.filter(i => i !== val);
    } else {
        likes.push(val);
    }
    return likes;
}

export default calcUsersInProject;
